import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Backend = () => {
  // Настройки слайдера
  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    variableWidth: true,
    centerPadding: "20px",
    responsive: [
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          centerPadding: "20px",
          variableWidth: false,
        },
      },
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          centerPadding: "20px",
          variableWidth: false,
        },
      },
      {
        breakpoint: 768, // Планшеты
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          variableWidth: false,
        },
      },
      {
        breakpoint: 450, // Мобильные устройства
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          variableWidth: false,
        },
      },
    ],
  };

  return (
    <section className="backend_section">
      <div className="bs_container">
        <h2 className="bs_title">Backend portfolio</h2>
        <div className="bs_project_card_container">
          <Slider {...settings}>
            <div className="bs_project_card">
              <div className="card-img-wrapper">
                <div className="card-img ailab-img">
                  <span className="bs_badge_fullstack ai-blood">Full Stack App</span>
                  <h3>AI - blood lab test analyzer</h3>
                  <div className="bs_project_descr">
                    <p>AI interpreter of blood lab tests result</p>
                  </div>
                </div>
              </div>

              <div className="bs_project_button_container">
                <a
                  href="https://lab-ai-blood-analyzer.vercel.app"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bs_project_button_descr"
                >
                  Live page
                </a>

                <a
                  href="https://github.com/MaksymChukhrai/lab-ai-blood-analyzer-be"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bs_project_button_repo"
                >
                  Repository
                </a>
              </div>
            </div>

            <div className="bs_project_card">
              <div className="card-img-wrapper">
                <div className="card-img eventhub-img">
                  <span className="bs_badge_fullstack ai-badge">Full Stack App</span>
                  <h3>AI - Event Management System</h3>
                  <div className="bs_project_descr">
                    <p>
                    AI-powered Event Management System with real-time notifications, calendar view, and tag filtering.
                  </p>
                  </div>
                </div>
              </div>

              <div className="bs_project_button_container">
                <a
                  href="https://frontend-production-8050.up.railway.app"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bs_project_button_descr"
                >
                  Live page
                </a>

                <a
                  href="https://github.com/MaksymChukhrai/Application"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bs_project_button_repo"
                >
                  Repository
                </a>
              </div>
            </div>

            <div className="bs_project_card">
              <div className="card-img-wrapper">
                <div className="card-img order-management-img">
                  <h3>Order Management App</h3>
                  <div className="bs_project_descr">
                    <p>
                      Full-featured order management application that allows
                      users to browse products, create orders and manage their
                      purchases.
                    </p>
                  </div>
                </div>
              </div>

              <div className="bs_project_button_container">
                <a
                  href="https://github.com/MaksymChukhrai/order-management-app/blob/main/README.md"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bs_project_button_descr"
                >
                  Full description
                </a>

                <a
                  href="https://github.com/MaksymChukhrai/order-management-app"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bs_project_button_repo"
                >
                  Repository
                </a>
              </div>
            </div>

            <div className="bs_project_card">
              <div className="card-img-wrapper">
                <div className="card-img bank-trans-img">
                  <h3>Banking Transactions API</h3>
                  <div className="bs_project_descr">
                    <p>API for working with banking transactions</p>
                  </div>
                </div>
              </div>

              <div className="bs_project_button_container">
                <a
                  href="https://github.com/MaksymChukhrai/backend-bank-operations/blob/main/README.md"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bs_project_button_descr"
                >
                  Full description
                </a>

                <a
                  href="https://github.com/MaksymChukhrai/backend-bank-operations"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bs_project_button_repo"
                >
                  Repository
                </a>
              </div>
            </div>

            <div className="bs_project_card">
              <div className="card-img-wrapper">
                <div className="card-img currency-exchange-img">
                  <h3>NBU Currency Exchange App</h3>
                  <div className="bs_project_descr">
                    <p>
                      TypeScript-based currency exchange application featuring
                      real-time NBU rates, modern React UI with comprehensive
                      validation.
                    </p>
                  </div>
                </div>
              </div>

              <div className="bs_project_button_container">
                <a
                  href="https://github.com/MaksymChukhrai/express-currency-converter/blob/main/README.md"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bs_project_button_descr"
                >
                  Full description
                </a>

                <a
                  href="https://github.com/MaksymChukhrai/express-currency-converter"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bs_project_button_repo"
                >
                  Repository
                </a>
              </div>
            </div>
          </Slider>
        </div>
      </div>
    </section>
  );
};

export default Backend;
